import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Button,
  Spinner,
  Badge,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";

import toast from "react-hot-toast";
import { Triangle } from "react-loader-spinner";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { imageBaseApi } from "../../../utilis/imageHelper";
import WidgetService from "../../../services/KangarooServices/Intelligence/WidgetService";

const DetailWidget = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchDetail = async () => {
    try {
      setLoading(true);
      const response = await WidgetService.getdetail(id);
      setDetails(response);
      setLoading(false);
    } catch (error) {
      console.log(error);
      toast.error("Failed to load details");
      setLoading(false);
      navigate("/who-we-are");
    }
  };

  useEffect(() => {
    // if () {
    fetchDetail();
    // }
  }, [id]);

  if (loading) {
    return (
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Who We Are Details" pageTitle="Who We Are" />
          <Card>
            <CardBody>
              <div className="d-flex justify-content-center align-content-center align-items-center text-center py-5">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
    );
  }

  if (!details) {
    return (
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Who We Are Details" pageTitle="Who We Are" />
          <Card>
            <CardBody>
              <div className="text-center py-5">
                <i className="ri-file-damage-line display-1 text-muted"></i>
                <h5 className="mt-4 mb-2">No Details Found</h5>
                <Button color="primary" onClick={() => navigate("/who-we-are")}>
                  Back to List
                </Button>
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
    );
  }
  const handleEdit = (slug) => {
    navigate(`/who-we-are/update/${slug}`);
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Widget Detail"
          pageTitle="Widgets"
          breadcrumbItems={[{ title: "Back to List", link: "/widgets" }]}
        />
        {/* <div className="d-flex justify-content-end align-content-center align-items-center mb-3">
          <Button
            color="warning"
            size="md"
            // className="flex-fill"
            onClick={(e) => {
              e.stopPropagation();
              handleEdit(details?.slug);
            }}
          >
            <i className="ri-pencil-line me-1"></i>
            Edit
          </Button>
        </div> */}
        <div>
          {/* Banner Section */}
          <Card className="mb-4 shadow-sm border">
            <CardHeader className="bg-white">
              <h5 className="mb-0 fw-semibold">
                <i className="ri-image-line me-2 text-primary"></i>
                Banner Information
              </h5>
            </CardHeader>
            <CardBody>
              {/* Banner Image */}
              <div className="mb-4">
                {details.image ? (
                  <img
                    src={`${imageBaseApi}${details.image.url}`}
                    alt="Banner"
                    className="img-fluid rounded"
                    style={{
                      width: "100%",
                      maxHeight: "320px",
                      objectFit: "contain",
                    }}
                  />
                ) : (
                  <div
                    className="d-flex align-items-center justify-content-center bg-light rounded"
                    style={{ height: "200px" }}
                  >
                    <div className="text-center">
                      <i className="ri-image-line display-4 text-muted mb-2"></i>
                      <p className="text-muted small mb-0">No banner image</p>
                    </div>
                  </div>
                )}
              </div>

              <Row className="g-3">
                {/* Banner Text */}
                <Col md={12}>
                  <div className="p-3 bg-light rounded">
                    <small className="text-muted text-uppercase fw-semibold d-block mb-2">
                      <i className="ri-text me-1"></i> Widget name
                    </small>
                    <p className="mb-0 fw-medium">{details.name || "N/A"}</p>
                  </div>
                </Col>

                <Col md={12}>
                  <div className="p-3 bg-light rounded">
                    <small className="text-muted text-uppercase fw-semibold d-block mb-2">
                      <i className="ri-text me-1"></i> Widget Heading Name
                    </small>
                    <p className="mb-0 fw-medium">
                      {details.headingName || "N/A"}
                    </p>
                  </div>
                </Col>

                <Col md={12}>
                  <div className="p-3 bg-light rounded">
                    <small className="text-muted text-uppercase fw-semibold d-block mb-2">
                      <i className="ri-text me-1"></i> Widget Description
                    </small>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: details.description 
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      </Container>
    </div>
  );
};

export default DetailWidget;
